export const genitourinary = (() => {
    const placeHolderText = 'No frequency, urgency, hematuria or dysuria.'

    return placeHolderText
})